<div class="help-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>help</mat-icon>
      Central de Ajuda
    </h2>
    <button mat-icon-button (click)="closeDialog()" aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    
    <!-- Help Sections -->
    <div class="help-sections">
      <h3>Guia de Uso</h3>
      <mat-accordion>
        @for (section of helpSections; track section.title) {
          <mat-expansion-panel [(expanded)]="section.expanded">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="section-icon">{{ section.icon }}</mat-icon>
                {{ section.title }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="section-content">{{ section.content }}</p>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>

    <mat-divider></mat-divider>

    <!-- FAQs -->
    <div class="faq-section">
      <h3>Perguntas Frequentes</h3>
      <mat-list>
        @for (faq of faqs; track faq.question) {
          <mat-list-item class="faq-item">
            <div class="faq-content">
              <div class="faq-question">
                <mat-icon class="faq-icon">help_outline</mat-icon>
                <strong>{{ faq.question }}</strong>
              </div>
              <div class="faq-answer">{{ faq.answer }}</div>
            </div>
          </mat-list-item>
        }
      </mat-list>
    </div>

    <!-- Contact Info -->
    <div class="contact-section">
      <h3>Precisa de mais ajuda?</h3>
      <div class="contact-info">
        <div class="contact-item">
          <mat-icon>phone</mat-icon>
          <span>Telefones: +55 19 3521-4646 e 3521-4647</span>
        </div>
        <div class="contact-item">
          <mat-icon>email</mat-icon>
          <span>E-mail: extecamp@extecamp.unicamp.br</span>
        </div>
        <div class="contact-item">
          <mat-icon>location_on</mat-icon>
          <span>Endereço: Rua Saturnino de Brito, nº 323, 2º andar. Cidade Universitária - Campinas - SP</span>
        </div>
        <div class="contact-item">
          <mat-icon>mail</mat-icon>
          <span>Endereço para correspondência: Escola de Extensão - UNICAMP - Caixa Postal 6085 - CEP: 13083-970 / Campinas-SP</span>
        </div>
        <div class="contact-item">
          <mat-icon>schedule</mat-icon>
          <span>Horário de atendimento: De segunda a sexta das 09:00 as 17:00</span>
        </div>
      </div>
    </div>

  </mat-dialog-content>

</div>
